import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { FILE_NOTES } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { POST, GET, DELETE, PUT } = HTTP_METHODS;
const { UPLOAD_FILES, FILE_NOTE, FILEUPLOAD_FILES_S3 } = FILE_NOTES;

export const filesApi = createApi({
  reducerPath: 'file-note',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    uploadFile: builder.mutation({
      query: (data) => ({ url: `${UPLOAD_FILES}`, method: POST, data })
    }),
    addFiles: builder.mutation({
      query: (data) => ({ url: `${FILE_NOTE}`, method: POST, data })
    }),
    getFileList: builder.query({
      query: (data) => ({ url: `${FILE_NOTE}/list${buildQueryString(data)}`, method: GET })
    }),
    deleteFiles: builder.mutation({
      query: (id) => ({
        url: `${FILE_NOTE}/?userId=${id.userId}&fileId=${id.fileId}`,
        method: DELETE
      })
    }),
    addNotes: builder.mutation({
      query: (data) => ({ url: `${FILE_NOTE}/note`, method: POST, data })
    }),
    getNoteList: builder.query({
      query: (data) => ({ url: `${FILE_NOTE}/notes${buildQueryString(data)}`, method: GET })
    }),
    deleteNotes: builder.mutation({
      query: (id) => ({
        url: `${FILE_NOTE}/note/${id}`,
        method: DELETE
      })
    }),
    editNotes: builder.mutation({
      query: (data) => ({
        url: `${FILE_NOTE}/note`,
        method: PUT,
        data: data
      })
    }),
    getIndividualNoteList: builder.query({
      query: (data) => ({ url: `${FILE_NOTE}/user/notes${buildQueryString(data)}`, method: GET })
    }),
    // deleteIndividualNotes: builder.mutation({
    //   query: (id) => ({
    //     url: `${FILE_NOTE}/user/note/?noteId=${id.noteId}&userId=${id.userId}`,
    //     method: DELETE
    //   })
    // }),
    editIndividualNotes: builder.mutation({
      query: (data) => ({
        url: `${FILE_NOTE}/user/note`,
        method: PUT,
        data: data
      })
    }),
    uploadFileS3: builder.mutation({
      query: (data) => ({
        url: `${FILEUPLOAD_FILES_S3}/upload`,
        method: POST,
        data: data
      })
    })
  })
});
export const {
  useUploadFileMutation,
  useAddFilesMutation,
  useGetFileListQuery,
  useDeleteFilesMutation,
  useAddNotesMutation,
  useGetNoteListQuery,
  useDeleteNotesMutation,
  useEditNotesMutation,
  useGetIndividualNoteListQuery,
  useDeleteIndividualNotesMutation,
  useEditIndividualNotesMutation,
  useUploadFileS3Mutation
} = filesApi;
